import { render, staticRenderFns } from "./NotFoundZh.vue?vue&type=template&id=337752e0&scoped=true&"
import script from "./NotFoundZh.vue?vue&type=script&lang=js&"
export * from "./NotFoundZh.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "337752e0",
  null
  
)

export default component.exports